import { render, staticRenderFns } from "./admin.role-claims.vue?vue&type=template&id=556f3966&"
import script from "./admin.role-claims.vue?vue&type=script&lang=js&"
export * from "./admin.role-claims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports